module.exports = __webpack_public_path__ + "static/media/shagi_copy_.81e5d50a.svg";